import { UseFormReturn } from 'react-hook-form';

export enum FORM_RADIO_TYPES {
  PRODUCTS = 'PRODUCTS',
  CUSTOMIZATIONS = 'CUSTOMIZATIONS',
  DATE = 'DATE',
  TIME = 'TIME',
  DATE_UNTIL = 'DATE_UNTIL',
  DAYS = 'DAYS',
  START_DATE = 'START_DATE',
  FORMS = 'FORMS',
  BUS_USER_TIME = 'BUS_USER_TIME'
}

export const FORM_RADIO_COMPONENT_TYPES = {
  PRODUCTS: {
    title: '',
    registerAs: 'products',
    requiredMessage: 'Please select an option',
    errorMessage: ''
  },
  CUSTOMIZATIONS: {
    title: '',
    registerAs: 'customizations',
    requiredMessage: 'Please select an option',
    errorMessage: ''
  },
  DATE: {
    title: 'Select the date and time for {{booking}}',
    registerAs: 'bookingDate',
    requiredMessage: 'Please select a date for your booking',
    errorMessage: 'Please select a date for each session'
  },
  TIME: {
    title: `Select a time for your booking on {{date}}.`,
    registerAs: 'bookingTime',
    requiredMessage: 'Please select a time for your booking',
    errorMessage: 'Please Select a time for each session'
  },
  DATE_UNTIL: {
    title: 'Select your arrival and departure dates',
    registerAs: 'bookingDateUntil',
    requiredMessage: 'Please select dates for your booking',
    errorMessage: 'Please select dates for your booking'
  },
  DAYS: {
    title: 'Select the days of your booking',
    registerAs: 'selectedDays',
    requiredMessage: 'Please select the days of your booking',
    errorMessage: 'Please select the days of your booking'
  },
  START_DATE: {
    title: 'When would you like your bookings to start?',
    registerAs: 'bookingStartDate',
    requiredMessage: 'Please select a date for your booking',
    errorMessage: 'Please select a date for each session'
  },
  FORMS: {
    title: 'Select the forms you would like to include',
    registerAs: 'forms',
    requiredMessage: 'Please select a form',
    errorMessage: ''
  },
  BUS_USER_TIME: {
    title: 'Select the time you would like to be picked up',
    registerAs: 'busUserTime',
    requiredMessage: 'Please select a time',
    errorMessage: ''
  }
} as const;

export type FormDateAndTime = UseFormReturn<{
  [x: string]: (string | string[] | undefined)[] | (readonly ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'] | undefined)[];
  selectedDays: (readonly ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'] | undefined)[];
  bookingTime: (string | undefined)[];
  busUserTime: (string | undefined)[];
}>;
